import styled from 'styled-components';

export const Container = styled.div``;

export const Form = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  @media (max-width: 1230px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
